module.exports = __webpack_public_path__ + "img/秋菊高潔_四方連續_線稿_black.06b6bb4a.png";